import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { openApp } from 'lib/helpers'
import useGenerateRefLink from '../../hooks/useGenerateRefLink'

import Button from 'components/Button'
import { HeaderTitle } from 'components/Header/YayHeaderTitle'

import './style.scss'

const Header = () => {
  const { t } = useTranslation()
  const refLink = useGenerateRefLink()
  const onOpenApp = useCallback(() => {
    if (typeof refLink !== 'undefined') {
      window.location.href = refLink
      return
    }

    openApp()
  }, [refLink])

  return (
    <div className="Header InviteHeader">
      <HeaderTitle />

      <Button size="medium" onClick={onOpenApp}>
        {t('invite_page.header.button')}
      </Button>
    </div>
  )
}

export default Header
